import styled, { CSSObject } from 'styled-components'

import { TransitionDurations } from '@/theme/defaults/transitions'

import { CollapseAnimationKeys, CollapseTimeoutKeys } from './collapse.types'

const TIMEOUT_MAP: Record<CollapseTimeoutKeys, keyof TransitionDurations> = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
}

interface StyledCollapseProps {
  $isExpanded: boolean
  $scrollHeight: number
  $collapsedSizeRem: number
  $timeout: CollapseTimeoutKeys
  $animation: CollapseAnimationKeys
}

export const Root = styled.div<StyledCollapseProps>(
  ({ theme, $isExpanded, $scrollHeight, $collapsedSizeRem, $timeout, $animation }) => {
    const duration = theme.transition.duration[TIMEOUT_MAP[$timeout]]
    const maxHeightValue = `${$scrollHeight / 10}rem`

    const animationStyles: Record<CollapseAnimationKeys, CSSObject> = {
      collapse: {
        maxHeight: $isExpanded ? maxHeightValue : `${$collapsedSizeRem}rem`,
        overflow: 'hidden',
        transition: `max-height ${duration} ease`,
      },
      fade: {
        opacity: $isExpanded ? 1 : 0,
        transition: `opacity ${duration} ease`,
      },
      grow: {
        maxHeight: $isExpanded ? maxHeightValue : '0rem',
        opacity: $isExpanded ? 1 : 0,
        overflow: 'hidden',
        transform: $isExpanded ? 'scale(1)' : 'scale(0.95)',
        transformOrigin: 'top center',
        transition: `max-height ${duration} ease, opacity ${duration} ease, transform ${duration} ease`,
      },
    }

    return animationStyles[$animation]
  },
)
